<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="400" v-model="showAddEditModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field type="text" v-model="dispatchCode.title" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="عنوان*" clearable
                clear-icon="mdi-close-circle-outline" class="input-label" :autofocus="true"
                prepend-inner-icon="mdi-text-box mdi-18px" tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="12" v-if="addFlag">
              <v-checkbox v-model="dispatchCode.hasNotification" label="ارسال اعلان" hide-details
                tabindex="2"></v-checkbox>
            </v-col>
            <v-col cols="6" v-if="!addFlag">
              <v-checkbox v-model="dispatchCode.hasNotification" label="ارسال اعلان" hide-details
                tabindex="2"></v-checkbox>
            </v-col>
            <v-col cols="6" v-if="!addFlag">
              <v-checkbox v-model="isActive" label="نمایش" hide-details tabindex="3"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت کدهای 800</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن کدهای 800
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="74vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="dispatchCodeManagmentInformationTableHeaders"
                          :items="dispatchCodeFilteredList" :items-per-page="dispatchCodeFilteredList.length"
                          height="59vh" :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.notification`]="{ item }">
                            <v-tooltip top v-if="item.notification == false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#F56060" v-bind="attrs" v-on="on">
                                  mdi-bell-off
                                </v-icon>
                              </template>
                              <span>عدم ارسال اعلان</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#3BCA79" v-bind="attrs" v-on="on">
                                  mdi-bell
                                </v-icon>
                              </template>
                              <span>ارسال اعلان</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.status`]="{ item }">
                            <v-tooltip top v-if="item.status == false">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#F56060" v-bind="attrs" v-on="on">
                                  mdi-eye-off
                                </v-icon>
                              </template>
                              <span>عدم نمایش</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="#3BCA79" v-bind="attrs" v-on="on">
                                  mdi-eye
                                </v-icon>
                              </template>
                              <span>نمایش</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import pagination from '@/Mixins/Pagination';
import dispatchCodeMixin from '@/Mixins/BaseInformation/DispatchCodeMixin';
import provinceMixin from '@/Mixins/BaseInformation/ProvinceMixin';
import dispatchCodeHelper from '@/Helpers/BaseInformation/DispatchCodeHelper';
export default {
  name: 'DispatchCodeManagment',
  title: 'کدهای 800',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
  },
  mixins: [
    pagination,
    ShearedMixin,
    dispatchCodeMixin,
    dispatchCodeHelper,
    snackBar,
    provinceMixin,
  ],
  created() {
    this.$root.$refs.DispatchCodeManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getListOfProvinces();
      this.getAllDispatchCodes();
    },
  },
  computed: {
    dispatchCodeFilteredList() {
      return this.allDispatchCodes.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
